import React from 'react'
import Footer from '../Components/Footer/Footer'

const FooterView = () => {
  return (
    <div>
        <Footer />
    </div>
  )
}

export default FooterView